package org.example.willfreightnew.components.models
import org.example.willfreightnew.components.util.Constants
import org.example.willfreightnew.components.util.Res

enum class Service(
    val icon: String,
    val imageDesc: String,
    val title: String,
    val description: String
) {
    Sameday(
        icon = Res.Image.SAMEDAY_ICON,
        imageDesc = "Calendar Icon",
        title = "SAME DAY",
        description = Constants.SAMEDAY_DESC
    ),
    LocalWorldwide(
        icon = Res.Image.LOCAL_WORLDWIDE_ICON,
        imageDesc = "Compass Icon",
        title = "LOCAL & WORLDWIDE",
        description = Constants.LOCAL_WORLDWIDE_DESC
    ),
    Pallet(
        icon = Res.Image.PALLET_ICON,
        imageDesc = "Truck Icon",
        title = "PALLET NETWORK",
        description = Constants.PALLET_NETWORK_DESC
    ),
    WhiteGlove(
        icon = Res.Image.WHITE_GLOVE_ICON,
        imageDesc = "Thumbs Up Icon",
        title = "WHITE GLOVE SERVICE",
        description = Constants.WHITE_GLOVE_DESC
    ),
    Hazardous(
        icon = Res.Image.HAZARDOUS_ICON,
        imageDesc = "Flag Icon",
        title = "HAZARDOUS ADR SHIPMENTS",
        description = Constants.HAZARDOUS_ADR_DESC
    ),
    Customs(
        icon = Res.Image.CUSTOMS_ICON,
        imageDesc = "Identification Icon",
        title = "CUSTOMS EXPERTISE",
        description = Constants.CUSTOMS_EXPERTISE_DESC
    )
}